import React, { useEffect, useRef, useState } from 'react';
import GoUpBtn from '../../common/GoUpBtn';
import GoUpParag from '../../common/GoUpParag';
import Loader from '../../common/Loader';
import MessageInfo from '../../common/MessageInfo';
import Img from '../../common/util/Img';
import MainContext from '../../contexts/MainContext';
import { getAllAgg } from '../../data/data';
import { useFetchMatch } from '../../data/fetchMatch';
import { useFetchSeoSettings } from '../../data/fetchSeoSettings';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import SeoMainContainer from '../../data/seo/SeoMainContainer';
import SeoMetaTags from '../../data/seo/SeoMetaTags';
import { useHandleSeoSettings } from '../../data/seo/seoUtils';
import { getStreamingId } from '../../data/streaming/streamingUtils';
import { classIf, getConfiguration, getMatchIdOrStageId, isLiveTrackerEnabled } from '../../data/utils';
import BetGeniusWidget from '../../data/widgets/BetGeniusWidget';
import BetradarWidget from '../../data/widgets/BetradarWidget';
import FlashbetWidget from '../../data/widgets/FlashbetWidget';
import StatsCoreWidget from '../../data/widgets/StatsCoreWidget';
import { bgWidgetEnabled, brWidgetS5Enabled, getBetgeniustWidgetUrl, getFlashbetWidgetUrl, isWidgetEnabled, statsCoreWidgetEnabled, STATSCORE_WIDGET_LIVESCORE, WidgetContext } from '../../data/widgets/WidgetContext';
import { ReactComponent as PinIcon } from '../../icons/pin.svg';
import { ReactComponent as FavoriteWh } from '../../icons/favoriteWh.svg';
import { getLabel } from '../../InitData';
import { useLayout } from '../../UISettingsProvider';
import LiveMatchBetGroup from '../common/LiveMatchBetGroup';
import Streaming from '../common/Streaming';
import StreamingIcon from '../common/StreamingIcon';
import { FavoriteMarketsContext } from '../live-suite/LiveSuiteCompetition';
import LiveMatchBet from './LiveMatchBet';
import LiveMatchHeader from './LiveMatchHeader';
import LiveScoresDisclaimer from '../common/LiveScoresDisclaimer';
import { systemCode } from '../..';

function findAggregata(sportId) {
    const agg = getAllAgg(true, sportId);
    return agg.idAggregata
}

function getInitState(match) {
    let favorites = localStorage.getItem('favorite_markets');
    if (favorites != null) {
        favorites = JSON.parse(favorites);
    } else {
        favorites = {};
    }

    if (favorites[match.sportRef] !== undefined) {
        return {
            showLoader: true,
            noData: false,
            data: null,
            matchFetch: match,
            match: null,
            aggregataFetch: findAggregata(match.sportRef),
            aggregata: null,
            landOnFavorites: true,
            setFavoritesAsSelected: true,
            favoritesSelected: false,
            favorites
        };
    } else {
        return {
            showLoader: true,
            noData: false,
            data: null,
            matchFetch: match,
            match: null,
            aggregataFetch: findAggregata(match.sportRef),
            aggregata: null,
            landOnFavorites: false,
            setFavoritesAsSelected: null,
            favoritesSelected: false,
            favorites
        };
    }
}

function getColumnsClass(columns) {
    switch (columns) {
        case 1:
            return 'unaColonna';
        case 2:
            return 'dueColonne';
        case 3:
            return 'treColonna';
        default:
            return 'dueColonne';
    }
}

function MatchView(props) {
    const cfgSeo = getConfiguration().seo;
    const layout = useLayout();
    const mainContext = React.useContext(MainContext);
    const widgetContext = React.useContext(WidgetContext);
    const seoContext = React.useContext(SeoContext);
    const conf = getConfiguration();
    const match = props.match;
    const widgetEnabled = isLiveTrackerEnabled() && isWidgetEnabled(match.sportRef, match.widgetType, match.geniusId, match.lsportWidgetId);
    const isBrWidgetS5 = brWidgetS5Enabled(match.sportRef, match.widgetType);
    const isBetgeniusWidget = bgWidgetEnabled(match.sportRef, match.widgetType, match.geniusId);
    const isStatsCoreWidget = statsCoreWidgetEnabled(STATSCORE_WIDGET_LIVESCORE, widgetContext.widgetProviderType, match.lsportWidgetId);
    const flashbetWidgetUrl = getFlashbetWidgetUrl(match.widgetType);
    const collapsedWidget = useRef({
        '#collassaWidgetMatchTop': true,
        '#collassaWidgetMatchRight': !widgetEnabled
    });
    const refScrollableContainer = useRef();
    const streamingId = getStreamingId(props.streaming);
    const streamingInfo = props.streaming;
    const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname, false, cfgSeo);
    const ctxs = useRef({}).current;
    ctxs.mainContext = mainContext;

    useHandleSeoSettings(seoSettingsState);

    const firstRender = useRef(true);

    let initState = (() => {
        if (firstRender.current === true) {
            firstRender.current = false;
        } else {
            return;
        }

        return getInitState(match);
    })();

    const [state, setState] = useState({
        ...initState,
        update(updt) {
            setState(prev => {
                return { ...prev, ...updt };
            });
        },
        setShowLoader(showLoader) {
            this.update({ showLoader });
        },
        setData(data) {
            if (Object.keys(data).length === 0) {
                this.update({ noData: true });
            } else if (this.setFavoritesAsSelected != null) {
                if (this.setFavoritesAsSelected === true) {
                    // I check whether there's any bets matching the favorite markets
                    let favorites = [];
                    try {
                        favorites = data.bets.filter(bet => {
                            return this.isMarketFavorite(this.matchFetch.sportRef, `${bet.id}_${bet.handicap}`) && bet.hasOdds;
                        });
                    } catch (e) {
                        console.error(e);
                    }
                    // If there are none, I show to the main bet group as selected by filtering only the bets that don't belong to it
                    if (this.landOnFavorites && favorites.length === 0) {
                        this.update({ showLoader: false, noData: false, data, match: this.matchFetch, aggregata: this.aggregataFetch, landOnFavorites: false, favoritesSelected: false, setFavoritesAsSelected: null });
                    } else {
                        this.update({ showLoader: false, noData: false, data, match: this.matchFetch, aggregata: this.aggregataFetch, landOnFavorites: false, favoritesSelected: true, setFavoritesAsSelected: null });
                    }
                } else {
                    this.update({ showLoader: false, noData: false, data, match: this.matchFetch, aggregata: this.aggregataFetch, landOnFavorites: false, favoritesSelected: false, setFavoritesAsSelected: null });
                }
            } else {
                if (data.gruppoById[this.aggregataFetch] == null) {
                    const ag = data.gruppiScommessa.find(a => a.idAggregata < 0).idAggregata
                    this.update({ showLoader: false, noData: false, data, match: this.matchFetch, aggregataFetch: ag, aggregata: ag, landOnFavorites: false });
                } else {
                    this.update({ showLoader: false, noData: false, data, match: this.matchFetch, aggregata: this.aggregataFetch, landOnFavorites: false });
                }

            }
        },
        changeAggregata(aggregataFetch) {
            if (this.aggregata !== aggregataFetch) {
                this.update({ aggregataFetch, setFavoritesAsSelected: false });
            } else if (this.favoritesSelected) {
                this.update({ favoritesSelected: false });
            }
        },
        changeMatch(matchFetch) {
            const aggregataFetch = findAggregata(matchFetch.sportRef);
            if (this.showFavoritesForSport(matchFetch.sportRef)) {
                this.update({ matchFetch, aggregataFetch, landOnFavorites: true, setFavoritesAsSelected: true });
            } else {
                this.update({ matchFetch, aggregataFetch, setFavoritesAsSelected: false });
            }
        },
        toggleFavorites() {
            const aggregataFetch = this.data.gruppiScommessa.find(bet => bet.idAggregata < 0).idAggregata;
            if (this.aggregata !== aggregataFetch) {
                if (this.favoritesSelected) {
                    this.update({ aggregataFetch, setFavoritesAsSelected: false });
                } else {
                    this.update({ aggregataFetch, setFavoritesAsSelected: true });
                }
            } else {
                this.update({ favoritesSelected: true });
            }
        },
        toggleFavorite(sportId, betId) {
            if (this.favorites[sportId] === undefined) {
                this.favorites[sportId] = {};
                this.favorites[sportId][betId] = true;
            } else {
                if (this.favorites[sportId][betId] === undefined) {
                    this.favorites[sportId][betId] = true;
                } else {
                    delete this.favorites[sportId][betId];
                    if (Object.keys(this.favorites[sportId]).length === 0) {
                        delete this.favorites[sportId];
                    }
                }
            }
            if (Object.keys(this.favorites).length > 0) {
                if (this.favorites[sportId] === undefined) {
                    this.update({ favoritesSelected: false });
                } else {
                    this.update({ favorites: { ...this.favorites } });
                }
                localStorage.setItem('favorite_markets', JSON.stringify(this.favorites));
            } else {
                this.update({ favorites: {}, favoritesSelected: false });
                localStorage.removeItem('favorite_markets');
            }
        },
        showFavoritesForSport(sportId) {
            return this.favorites[sportId] !== undefined;
        },
        isMarketFavorite(sportId, betId) {
            return this.favorites[sportId] !== undefined && this.favorites[sportId][betId] !== undefined;
        }
    });

    const expandToggle = useRef(null);
    const collapseToggle = useRef(null);
    function toggleCollapse(collapse) {
        document.querySelectorAll('.colonne-evento-live .quote-extra-partita').forEach(el => {
            const children = el.children;
            if (collapse) {
                children[0].classList.add('collapsed');
                children[1].classList.remove('show');
            } else {
                children[0].classList.remove('collapsed');
                children[1].classList.add('show');
            }
        });
        collapseToggle.current.classList.toggle('d-none');
        expandToggle.current.classList.toggle('d-none');
    }
    function handleExpand() {
        toggleCollapse(false);
    }
    function handleCollapse() {
        toggleCollapse(true);
    }

    function handleStreamingButton(container = 'betslip') {
        if(conf.smvc) {
            container = 'matchView';
        }
        //mainContext.toggleStreamingGeniusFid(props.streaming.fid,'betslip');
        ctxs.mainContext.toggleStreaming(streamingInfo, streamingId, match.id, container);
    }

    function resetStreaming() {
        ctxs.mainContext.toggleStreaming(null, null, null);
    }

    const setCollapsedWidget = (id, value) => {
        collapsedWidget.current[id] = value;
    }

    function changeAggregata(ag) {
        state.changeAggregata(ag);
    }

    function toggleFavorites() {
        state.toggleFavorites();
    }

    useEffect(function () {
        if (state.match != null) {
            state.changeMatch(props.match);
        }
        if (conf?.lstwc) {
            handleStreamingButton('betradar-widget');
        } else {
            handleStreamingButton();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.match]);

    const [request, , isSetInterval] = useFetchMatch(state.matchFetch, state.aggregataFetch, true, false, true);

    useEffect(function () {
        let timeout = null;
        if (request.isLoading) {
            timeout = setTimeout(function () {
                state.setShowLoader(true);
            }, conf?.lspt);
        } else {
            clearTimeout(timeout);
            if (!request.isError) {
                state.setData(request.data);
                const settings = {
                    widgetGeniusId: match.geniusId,
                    widgetLsportId: match.lsportWidgetId,
                    widgetProviderType: match.widgetType,
                    widgetSportId: match.sportRef
                };
                if (widgetContext.widgetMatchId !== match.id) {
                    Object.keys(collapsedWidget.current).forEach(function (key) {
                        if (!collapsedWidget.current[key]) {
                            Object.assign(settings, {
                                widgetStartCollapsed: false,
                                widgetS5Layout: key === "#collassaWidgetMatchRight" ? '#1' : '#2',
                                widgetMatchId: getMatchIdOrStageId(match),
                                widgetContainerId: key
                            });
                        }
                    });
                    const showSidebar = !collapsedWidget.current["#collassaWidgetMatchRight"];
                    Object.assign(settings, {
                        widgetShowSidebar: showSidebar
                    });
                }
                widgetContext.setWidget(settings);
            } else {
                state.setShowLoader(true);
            }
        }

        return () => {
            clearInterval(timeout);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request]);

    function handleWidgetButton(containerId, event) {
        event.preventDefault();
        event.stopPropagation();

        const settings = {
            widgetStartCollapsed: false,
            widgetS5Layout: collapsedWidget.current["#collassaWidgetMatchRight"] ? '#1' : '#2'
        };
        if (widgetContext.widgetMatchId === null) { // widget chiuso, lo apro
            Object.assign(settings, {
                widgetMatchId: getMatchIdOrStageId(state.match),
                widgetContainerId: containerId
            });
            setCollapsedWidget(containerId, !collapsedWidget.current[containerId]);
        } else { // widget aperto
            if (widgetContext.widgetMatchId === state.match.id) {// widget aperto su match corrente
                if (state.match.id && widgetContext.widgetContainerId === containerId) {// chiamata arriva da container in cui e' aperto il widget, lo chiudo
                    Object.assign(settings, {
                        widgetMatchId: null,
                        widgetContainerId: null
                    });
                    setCollapsedWidget(containerId, !collapsedWidget.current[containerId]);
                } else {// chiamata arriva da altro container, faccio switch
                    Object.assign(settings, {
                        widgetContainerId: containerId
                    });
                    Object.keys(collapsedWidget.current).forEach(function (key) {
                        setCollapsedWidget(key, !collapsedWidget.current[key]);
                    });
                    if (conf?.lstwc) {
                        if (ctxs.mainContext.streamingId != streamingId && ctxs.mainContext.streamingMatchId != state.match.id) {
                            handleStreamingButton('betradar-widget');
                        } else {
                            ctxs.mainContext.setStreamingContainer('betradar-widget');
                        }
                    }
                }
            }
            const showSidebar = !collapsedWidget.current["#collassaWidgetMatchRight"];
            Object.assign(settings, {
                widgetShowSidebar: showSidebar
            });
        }

        widgetContext.setWidget(settings);

        if (!collapsedWidget.current[containerId]) {
            state.setShowLoader(false);
        }
    }

    const hideTopWidget = collapsedWidget.current['#collassaWidgetMatchTop'];
    const hideSideWidget = collapsedWidget.current['#collassaWidgetMatchRight'];
    let containerClasses = '';
    if (!hideTopWidget && widgetEnabled) {
        containerClasses += 'aperto-widget-evento-su';
    } else if (!hideSideWidget && widgetEnabled) {
        containerClasses += 'aperto-widget-evento-dx';
    }

    if (state.data == null || state.data.bets == null) {
        return (
            <div className={`griglia-centrale-sport col stringimento-sidebar evento-live-centrale justify-content-between go-up-arrow-on-overflow ${layout.order.divCentrale} ${containerClasses}`} id="div-centrale">
                <Loader error={request.isError} />
            </div>
        );
    }

    const betGroupsList = state.data.gruppiScommessa.map(function (betGroup, i) {
        const active = !state.favoritesSelected && betGroup.idAggregata === state.aggregata;
        const conf = getConfiguration();

        return (
            <React.Fragment key={i}>
                {(i === 0 && state.showFavoritesForSport(state.match.sportRef)) &&
                    <div className={"bg-bianco nero bordo-tondo elemento-macro-sub pointer filter subgoals" + classIf(state.favoritesSelected, 'icona-selezionata')} onClick={toggleFavorites}>
                        {getLabel('favorite_markets')}
                        {conf.iwh ?
                            <FavoriteWh className="pin-icon ml-2"></FavoriteWh>
                            :
                            <PinIcon className="pin-icon ml-2"></PinIcon>}
                    </div>
                }
                <LiveMatchBetGroup active={active} desc={betGroup.descrizione} idAggregata={betGroup.idAggregata} changeAggregata={changeAggregata} />
            </React.Fragment>
        );
    });

    let bets = state.data.bets.filter(bet => {
        if (!bet.hasOdds) {
            return false;
        } else if (state.favoritesSelected) {
            return state.isMarketFavorite(state.match.sportRef, `${bet.id}_${bet.handicap}`);
        }
        return true;
    });
    const betsList = bets.map((bet, index) => {
        return (
            <LiveMatchBet key={bet.uniqueId || index} {...bet} matchData={state.match} alt="" />
        );
    });

    const parts = (state.data.score || state.match.score).combinedScore.split(' - ');
    const team1Score = parts[0];
    const team2Score = parts[1];
    const partialScores = (state.data.score || state.match.score).currentScore.filter((s, i) => i > 0);
    const columns = conf.iwh ? 1 : (conf?.lec || 2);

    
    function openLiveSection(e) {
        e.preventDefault();
        e.stopPropagation();
        window.openSection('live');
    }

    return (
        <>
            <SeoMetaTags />
            <FavoriteMarketsContext.Provider value={state}>
                <div ref={refScrollableContainer} className={`griglia-centrale-sport col stringimento-sidebar evento-live-centrale justify-content-between go-up-arrow-on-overflow ${layout.order.divCentrale} ${containerClasses}`} id="div-centrale">
                    <GoUpBtn />
                    <div className="blocco-interno-evento w-100">
                        {(hideTopWidget || !widgetEnabled) &&
                            <LiveMatchHeader {...state.match} {...state.data} team1Score={team1Score} team2Score={team2Score} partialScores={partialScores} />
                        }
                        <div className={"widget-stats w-superiore margine-giu-mezzo " + (hideTopWidget || !widgetEnabled ? "d-none" : "")}>
                            {!hideTopWidget && widgetEnabled &&
                                <div className={`widget-filtro-side margine-giu live-tracker-widget ${isBetgeniusWidget ? 'betgeniusWidget' : ''}`}>

                                    {flashbetWidgetUrl ?
                                        <FlashbetWidget url={flashbetWidgetUrl} />
                                        :
                                        isBetgeniusWidget ?
                                            <BetGeniusWidget url={getBetgeniustWidgetUrl(match.sportRef, match.categoryRef, match.tournamentRef)} />
                                            :
                                            isStatsCoreWidget ?
                                                <StatsCoreWidget />
                                                :
                                                <BetradarWidget id={"collassaWidgetMatchTop"} matchId={match.id} className={`bordato-widget collapse show ${isBrWidgetS5 ? 'brWidgetS5' : ''}`}
                                                    streamingComponent={<Streaming container="betradar-widget" />} streamingContainer={mainContext.streamingContainer}
                                                    streaming={props.streaming} toggleStreaming={handleStreamingButton} resetStreaming={resetStreaming} mainContext={mainContext} />
                                    }
                                </div>
                            }

                        </div>
                         {systemCode === 'STARCASINO' && <i className="close-icon__details-live pointer"  onClick={(e) => openLiveSection(e)} ></i>}
                    </div>

                    <div className="d-flex">
                        <div className={"blocco-interno-evento " + (!hideSideWidget && widgetEnabled ? "col-sm-8" : "col-sm-12")}>

                            {conf.iwh &&
                                <div className=" blocco-interno-evento w-100 blocco-interno-evento-wh">

                                    {(hideTopWidget || !widgetEnabled) &&
                                        <LiveMatchHeader {...state.match} {...state.data} team1Score={team1Score} team2Score={team2Score} partialScores={partialScores} />
                                    }
                                    <div className={"widget-stats w-superiore margine-giu-mezzo " + (hideTopWidget || !widgetEnabled ? "d-none" : "")}>

                                        {!hideTopWidget && widgetEnabled &&
                                            <div className={`widget-filtro-side margine-giu live-tracker-widget ${isBetgeniusWidget ? 'betgeniusWidget' : ''}`}>

                                                {flashbetWidgetUrl ?
                                                    <FlashbetWidget url={flashbetWidgetUrl} />
                                                    :
                                                    isBetgeniusWidget ?
                                                        <BetGeniusWidget url={getBetgeniustWidgetUrl(match.sportRef, match.categoryRef, match.tournamentRef)} />
                                                        :
                                                        isStatsCoreWidget ?
                                                            <StatsCoreWidget />
                                                            :
                                                            <BetradarWidget id={"collassaWidgetMatchTop"} matchId={match.id} className={`bordato-widget collapse show ${isBrWidgetS5 ? 'brWidgetS5' : ''}`}
                                                                streamingComponent={<Streaming container="betradar-widget" />} streamingContainer={mainContext.streamingContainer}
                                                                streaming={props.streaming} toggleStreaming={handleStreamingButton} resetStreaming={resetStreaming} mainContext={mainContext} />
                                                }
                                            </div>
                                        }

                                    </div>
                                </div>

                            }
                            {(!isSetInterval && state.showLoader) ?
                                <Loader error={request.isError} />
                                :
                                <>
                                    {state.noData || (state.data.giocabilita != null && !state.data.giocabilita) ?
                                        <MessageInfo message={getLabel('general.giocabilita_chiusa')} />
                                        :
                                        <>
                                            <div className="toolbox-evento justify-content-center padding-orizzontale bg-nero bianco bordo-tondo d-flex margine-giu-mezzo">
                                                {columns > 1 &&
                                                    <div className="selettore-colonne-evento d-flex justify-content-around w-50">
                                                        <a href="#!" id="ev-una-colonna" className={`pointer ${conf.iwh && "selezionato-toolbox"}`} >{getLabel('general.1_col')}</a>
                                                        <a href="#!" id="ev-due-colonne" className={`pointer ${!conf.iwh && "selezionato-toolbox"}`}>{getLabel('general.2_col')}</a>
                                                        <a href="#!" id="ev-tre-colonne" className="pointer">{getLabel('general.3_col')}</a>
                                                    </div>
                                                }
                                                <div className="strumenti-toolbox-evento">
                                                    {streamingId && !conf.lstwc &&
                                                        <a href="#!" className="widget-evento">
                                                            <StreamingIcon src="assets\img\sport\icone\tv-streaming-white.svg" alt="" className="pointer img-tv-streaming" onClick={(e) => { handleStreamingButton() }} />
                                                        </a>
                                                    }
                                                    <a href="#!" className={"widget-evento apri-widget-evento-dx pointer " + (!widgetEnabled ? "d-none" : "")} onClick={(e) => handleWidgetButton('#collassaWidgetMatchRight', e)}>
                                                        <Img src="assets/img/sport/campetto-icona.svg" className="img-fluid" alt="" />
                                                    </a>
                                                    <a href="#!" className={"widget-evento apri-widget-evento-su pointer " + (!widgetEnabled ? "d-none" : "")} onClick={(e) => handleWidgetButton('#collassaWidgetMatchTop', e)}>
                                                        <Img src="assets/img/sport/campetto-icona.svg" className="img-fluid" alt="" />
                                                    </a>
                                                    <a href="#!" className="pointer" id="riduci-eventi">
                                                        <span className="voce-riduci" ref={expandToggle} onClick={handleCollapse}>{getLabel('general.collapse_all')}</span>
                                                        <span className="voce-riduci d-none" ref={collapseToggle} onClick={handleExpand}>{getLabel('general.expand_all')}</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="macro-gruppi margine-giu">
                                                <div className="aggregate">
                                                    {betGroupsList}
                                                </div>
                                            </div>
                                            {state.favoritesSelected && betsList.length === 0 ?
                                                <div className="text-center">{getLabel('favorite_markets.add_markets')}</div>
                                                :
                                                <div className={"colonne-evento-live d-grid " + getColumnsClass(columns)}>
                                                    {betsList}
                                                </div>
                                            }
                                            <LiveScoresDisclaimer />
                                            <GoUpParag refScrollableContainer={refScrollableContainer} />
                                        </>
                                    }
                                </>
                            }
                        </div>
                       
                        <div className={"widget-stats w-destro margine-sx-mezzo " + (hideSideWidget || !widgetEnabled ? "d-none" : "col-sm-4")}>
                            {conf.smvc && 
                                <Streaming container="matchView" />
                            }
                            {!hideSideWidget && widgetEnabled &&
                                <div className={`widget-filtro-side margine-giu live-tracker-widget ${isBetgeniusWidget ? 'betgeniusWidget' : ''}`}>
                                    {flashbetWidgetUrl ?
                                        <FlashbetWidget url={flashbetWidgetUrl} />
                                        :
                                        isBetgeniusWidget ?
                                            <BetGeniusWidget url={getBetgeniustWidgetUrl(match.sportRef, match.categoryRef, match.tournamentRef)} />
                                            :
                                            isStatsCoreWidget ?
                                                <StatsCoreWidget />
                                                :
                                                <BetradarWidget id={"collassaWidgetMatchRight"} matchId={match.id} className={`bordato-widget collapse show ${isBrWidgetS5 ? 'brWidgetS5' : ''}`} isBrWidgetS5={isBrWidgetS5}
                                                    streamingComponent={<Streaming container="betradar-widget" />} streamingContainer={mainContext.streamingContainer}
                                                    streaming={props.streaming} toggleStreaming={handleStreamingButton} resetStreaming={resetStreaming} mainContext={mainContext} />
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <SeoMainContainer />
                </div>
            </FavoriteMarketsContext.Provider>
        </>
    );
}

export default MatchView;
